var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationRequestIcon = function SvgNotificationRequestIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 16 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D252D",
    fillRule: "evenodd",
    d: "M12.325 16.39c-.868.924-2.214 1.271-3.424 1.479-.662-.023-1.324-.81-1.141-1.48l.297-1.155a4.3 4.3 0 0 1 1.118-2.011l6.162-6.242V1.225A1.21 1.21 0 0 0 14.127 0H5.456v4.3c0 .67-.548 1.225-1.21 1.225H0v13.5c0 .67.548 1.225 1.21 1.225h12.918c.662 0 1.21-.555 1.21-1.225V13.36c-.332.324-.914.913-1.498 1.506-.586.592-1.173 1.187-1.515 1.523M4.428.324v3.953a.157.157 0 0 1-.16.161H.32l.045-.046c.029-.019.714-.711 1.514-1.52C3.012 1.728 4.374.351 4.428.324m14.356 6.334a1.174 1.174 0 0 0-1.666 0l-.525.531 1.666 1.688.525-.532a1.21 1.21 0 0 0 0-1.687m-2.945 1.294-5.934 6.01c-.627.575-.86 1.53-1.064 2.369l-.077.313c-.023.093.068.185.16.162l.362-.09c.814-.2 1.73-.424 2.285-1.066l5.934-6.01c-.045-.07-1.666-1.688-1.666-1.688",
    clipRule: "evenodd"
  })));
};
export default SvgNotificationRequestIcon;